import { useCallback, useEffect, useRef } from 'react';
export function useClickOutside(handler) {
    var ref = useRef(null);
    var handleClick = useCallback(function (event) {
        event.target;
        if (!ref.current || ref.current.contains(event.target)) {
            return;
        }
        handler(event);
    }, [handler]);
    useEffect(function () {
        document.addEventListener('mousedown', handleClick);
        document.addEventListener('touchstart', handleClick);
        return function () {
            document.removeEventListener('mousedown', handleClick);
            document.removeEventListener('touchstart', handleClick);
        };
    }, [handleClick]);
    return ref;
}
//# sourceMappingURL=index.js.map